import { Controller } from "@hotwired/stimulus"

// FD-1173: the dashboard widget form. An initiative board has no group-by, measure, scope
// or PQL, so those fields hide while that chart type is chosen, and a one-line note takes
// their place. Display only: DashboardWidgetsController stores an empty config for a board
// whatever the form sends.
export default class extends Controller {
  static targets = ["type", "workItemFields", "boardNote"]

  connect() {
    this.toggle()
  }

  toggle() {
    const board = this.typeTarget.value === "initiative_board"
    this.workItemFieldsTarget.hidden = board
    if (this.hasBoardNoteTarget) this.boardNoteTarget.hidden = !board
  }
}
